export var ParticipantsView;
(function (ParticipantsView) {
    ParticipantsView["Grid"] = "grid";
    ParticipantsView["List"] = "list";
})(ParticipantsView || (ParticipantsView = {}));
export const SELF_PARTICIPANT_ID = 'self';
export const MOBILE_LAYOUT_BODY_CSS_MODIFIER = 'mobile-layout';
export const NO_SOUND_LEVEL = 0;
export const VISIBLE_PARTICIPANTS_COUNT = 3;
export const IDLE_SCHEDULE = [5000, 3000];
export var DeviceOrientation;
(function (DeviceOrientation) {
    DeviceOrientation["Portrait"] = "portrait";
    DeviceOrientation["Landscape"] = "landscape";
})(DeviceOrientation || (DeviceOrientation = {}));
